import { Component, HostListener, OnInit } from '@angular/core';
import { HomeMessage } from '@app/@shared/models/home-message';
import { HomeMessageService } from '@app/@shared/services/home-message.service';
import { CardModel } from '@shared/models/card.model';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ViewportScroller } from '@angular/common';
import { Config } from '@core/config';
import { Title } from '@angular/platform-browser';
import { GAService } from '@app/@shared/services/google-analytics.service';

@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
})
export class HomeComponent implements OnInit {
  public quote: string | undefined;
  public homeMessage: HomeMessage;
  public hidden = true;
  public cols: string;
  public highlight: CardModel[];
  public sideCol: number;
  public nbCol: number;
  public images = Config.imageCategories;
  public current: number;
  public exploreData: { name: string; image: string }[];
  public isMobile: boolean;
  public currentScreenWidth: number;
  public currentScreenHeight: number;
  public responsiveRowValue: number;
  public responsiveCardSizeValue: number;

  private expandedPanel: boolean = false;

  constructor(
    private homeMessageService: HomeMessageService,
    private breakpointObserver: BreakpointObserver,
    private viewport: ViewportScroller,
    private titleService: Title,
    public gaService: GAService
  ) {
    this.titleService.setTitle('MyBalade');
    this.isMobile =
      /Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
        navigator.userAgent
      );
    if (this.isMobile) {
      this.current = 0;
      this.exploreData = [];
      // tslint:disable-next-line:forin
      for (const key in this.images) {
        this.exploreData.push({
          name: key,
          image: this.images[key],
        });
      }
    }
  }

  ngOnInit() {
    this.onResize();
    this.breakpointObserver
      .observe(['(max-width: 1700px)'])
      .subscribe((result) => {
        if (result.matches) {
          this.sideCol = 0;
          this.nbCol = 4;
        } else {
          this.sideCol = 1;
          this.nbCol = 6;
        }
      });

    this.filterCurrentHomeMessage();
  }

  /**
   * Set the current @this _currentScreenWidth attribute with actual screen width device.
   */
  @HostListener('window:resize', ['$event'])
  onResize() {
    this.currentScreenWidth = this.isMobile
      ? window.screen.width
      : window.innerWidth;
    this.currentScreenHeight = window.innerHeight;
    this.responsiveRowValue = this.currentScreenWidth >= 1400 ? 4 : 2;
    this.responsiveCardSizeValue =
      this.currentScreenWidth >= 1400
        ? 550
        : this.currentScreenWidth / 4 > 260
        ? this.currentScreenWidth / 4
        : 260;
  }

  public filterCurrentHomeMessage(): void {
    this.homeMessageService
      .getHomeMessages()
      .subscribe((homeMessage: { homeMessage: HomeMessage }) => {
        if (homeMessage.homeMessage) {
          this.homeMessage = homeMessage.homeMessage;
          const theDateEnd = new Date(this.homeMessage.dateEnd);
          const currentDate = new Date();
          if (currentDate >= theDateEnd) return;
          this.homeMessage.dateStart = new Date(this.homeMessage.dateStart);
          this.homeMessage.dateEnd = new Date(this.homeMessage.dateEnd);
          this.hidden = false;
        }
      });
  }

  public scrollToTop(): void {
    this.viewport.scrollToPosition([0, 0]);
  }

  public navForward(): void {
    this.current =
      this.current + 1 < this.exploreData.length ? this.current + 1 : 0;
  }

  public navBackward(): void {
    this.current =
      this.current - 1 >= 0 ? this.current - 1 : this.exploreData.length - 1;
  }

  public scrollTo(id: string) {
    document.getElementById(id).scrollIntoView();
  }

  /**
   * Callback on header click.
   * Also send Home GA event.
   */
  public clickPanel(): void {
    this.expandedPanel = !this.expandedPanel;
    const element = document.getElementById('expension-info-panel');
    if (this.expandedPanel) {
      element.scrollIntoView();
      this.gaService.sendEvent('A la une', 'Home', this.homeMessage.title);
    }
  }

  /**
   * Send generic GA event.
   * @param {string} event
   */
  public sendGaEvent(event: string, categ: string, label?: string): void {
    this.gaService.sendEvent(event, categ, label);
  }
}
